__webpack_require__.p = "/static-cars/";